import Vue from "vue";

// GLOBAL CONSTANTS
import constants from "@/constants";


// SUBSCRIBER
// import subscriber from "@/subscription";

// DEPENDENCIES
import axios from "./setup/axios-setup";

// UTILITIES
import { setDebugStatus } from '@/utils/debug';

export default Vue.observable({
  axios,
  constants,
  envs: process.env,
  developing: process.env.NODE_ENV === "development",
  debug: setDebugStatus(),
  // subscriber
});
